// 国家法律管辖条款映射表
// key 与接口返回的 country 全称一致，未匹配时显示空
// 未来扩展：Cayman Islands、Virgin Islands, British
export const governingLawClauseRegistry = {
  Singapore: {
    en: "This letter shall be governed by and construed in accordance with the laws of the Republic of Singapore. The parties shall submit to the exclusive jurisdiction of the courts of Singapore.",
    cn: "本协议的司法管辖以及司法解释适用新加坡共和国法律。各方应服从新加坡法院的仲裁及管辖。",
  },
  Malaysia: {
    en: "This letter shall be governed by and construed in accordance with the laws of Malaysia. The parties shall submit to the exclusive jurisdiction of the courts of Malaysia.",
    cn: "本协议的司法管辖以及司法解释适用马来西亚法律。各方应服从马来西亚法院的仲裁及管辖。",
  },
};
